export const formatDate = (dateString: string) => {
  if (typeof dateString !== "string" || dateString.length !== 8) {
    return "-";
  }

  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);

  return `${year}.${month}.${day}`;
};

export const formatTime = (timeString: string) => {
  if (typeof timeString !== "string" || timeString.length !== 4) {
    return "-";
  }

  const hours = timeString.slice(0, 2);
  const minutes = timeString.slice(2, 4);

  return `${hours}:${minutes}`;
};
